import React from 'react'
import ReactDOM from 'react-dom'
import thunk from "redux-thunk"
import { createStore, applyMiddleware, Store } from "redux"
import { Provider } from "react-redux"

import { Web3ContextProvider } from "./hooks";

import Providers from './Providers'
import App from './App'
import reducer from "./store/reducer"

const store: Store<ArticleState, ArticleAction> & {
  dispatch: DispatchType
} = createStore(reducer, applyMiddleware(thunk))

const rootElement = document.getElementById("root")

ReactDOM.render(
  <React.StrictMode>
    <Providers>
      <Provider store={store}>
        <Web3ContextProvider>
          <App />
        </Web3ContextProvider>
      </Provider>
    </Providers>
  </React.StrictMode>,
  rootElement
)
